<template>
  <div class="breadcrumbs">
    <ul>
      <li v-for="(link, index) in links" :key="index">
        <NuxtLink
          v-if="link.href && index < links.length - 1"
          :to="link.href"
        >
          {{ link.name }}
        </NuxtLink>
        <span v-else>{{ link.name }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      default: () => undefined,
    },
    category: {
      type: Object,
      default: () => undefined,
    },
    subcategory: {
      type: Object,
      default: () => undefined,
    },
  },
  computed: {
    query() {
      const parts = this.$route.fullPath.split('?');

      if (parts.length > 1) {
        return `?${parts[1].split('#')[0]}`;
      }

      return '';
    },
    links() {
      const ret = [];

      if (this.group) {
        ret.push({
          ...this.group,
          href: `/${this.group.value}${this.query}/`,
        });

        if (this.category) {
          ret.push({
            ...this.category,
            href: `/${this.group.value}/${this.category.value}${this.query}/`,
          });

          if (this.subcategory) {
            ret.push({
              ...this.subcategory,
            });
          }
        }
      }

      return ret;
    },
  },
};
</script>
<style lang="scss" scoped>
.breadcrumbs {
  margin-bottom: 24px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #1b1b1b;

    li + li::before {
      content: '/\00a0';
      margin-left: 5px;
    }

    li {
      display: inline;

      a {
        color: #0e6ef4;
        text-decoration: none;
      }

      a:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
